export default __webpack_public_path__ + "static/Cute1-e77ed3364a16ed48adaf4300cc30eef3.mp3";